import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.css']
})
export class TncComponent implements OnInit {

  constructor(
    private metaService: Meta,
    private titleService: Title,
    protected $gaService: GoogleAnalyticsService,
    private activatedRoute: ActivatedRoute,
  ) { }

  public pageSlug;
  public pageTitle = 'Terms and Conditions';

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      this.pageSlug = params.slug;
    });

    // Google analytics
    this.$gaService.pageView('/experience/' + this.pageSlug, this.pageTitle);

    this.metaService.addTag({name: 'copyright', content: 'Things2do'});
    this.metaService.addTag({name: 'robots', content: 'index,follow'});
    this.titleService.setTitle(this.pageTitle);
  }

}
